export type InitialStateConfig = {
  drawerCollapsed: boolean;
};

export const DRAWER_COLLAPSED = 'DRAWER_COLLAPSED';
interface DrawerCollapsed {
  type: typeof DRAWER_COLLAPSED;
  payload: boolean;
}

export type ConfigActionTypes = DrawerCollapsed;
